export const convertSymbolsToEncodedUnicode = (str) => {
    return str.replace(/[^A-Za-z0-9():%"_\- ]/g, (i) => {
        const code = '0000' + i.charCodeAt(0).toString(16).toUpperCase();
        return '%5Cu' + code.substring(code.length - 4);
    });
};
